function cleanListWithExtraValue<T>(values?: T[], value?: T): T[] {
  if (!value) return values || [];
  const v = [...new Set([...(values || []), value])].filter(Boolean);
  v.sort();
  return v;
}

export default cleanListWithExtraValue;
